import React from 'react';

interface Props {
  label: string;
  value: string;
  /** Pixel width of the inline label — match the surrounding tab's LBL. */
  labelWidth?: number;
  /** Pixel width of the value column (keeps it aligned with the inputs above). */
  inputWidth?: number;
}

/**
 * Yellow callout row used for computed totals (e.g. Total With Charges, Total
 * Dray & Handling). Computed, never editable — so the value renders as plain
 * text (not an input) to make clear it can't be hand-edited.
 */
const AutoCalcRow: React.FC<Props> = ({ label, value, labelWidth = 100, inputWidth = 120 }) => (
  // No left padding + a right-aligned label so the value lines up with the
  // surrounding `Row`/`Label` inputs (which sit flush at the card-body edge).
  <div className="bg-yellow-50 border border-yellow-500 rounded my-1 pr-2 py-1.5 flex items-center gap-2 dark:bg-yellow-900/20 dark:border-yellow-700">
    <span className="text-[0.71875rem] font-bold text-yellow-900 dark:text-yellow-300 flex-shrink-0 text-right" style={{ width: labelWidth }}>
      {label}
    </span>
    <span className="text-[0.78125rem] font-semibold text-yellow-900 dark:text-yellow-200 px-1.5" style={{ minWidth: inputWidth }}>
      {value}
    </span>
  </div>
);

export default AutoCalcRow;
